/**
 * Suscripción única al canal realtime de tareas. Se monta una vez desde
 * AppLayout. Hace invalidaciones gruesas en lugar de mergear payloads
 * (más simple y suficiente para el tamaño de cargas actual).
 */
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { subscribeToTasks, type TaskRealtimeEvent } from '../realtime';
import { TASK_KEYS } from './keys';

export function useTasksRealtimeInvalidator(): void {
  const qc = useQueryClient();
  useEffect(() => {
    const handle = (event: TaskRealtimeEvent) => {
      switch (event.kind) {
        case 'task':
          qc.invalidateQueries({ queryKey: ['core', 'tasks'] });
          qc.invalidateQueries({ queryKey: TASK_KEYS.myDue });
          break;
        case 'assignment':
          if (event.taskId) {
            qc.invalidateQueries({ queryKey: TASK_KEYS.assignments(event.taskId) });
          }
          qc.invalidateQueries({ queryKey: ['core', 'tasks'] });
          break;
        case 'comment':
          if (event.taskId) {
            qc.invalidateQueries({ queryKey: TASK_KEYS.comments(event.taskId) });
          }
          break;
        case 'activity':
          if (event.taskId) {
            qc.invalidateQueries({ queryKey: TASK_KEYS.activity(event.taskId) });
          }
          break;
      }
    };
    const channel = subscribeToTasks(handle);
    return () => {
      void channel.unsubscribe();
    };
  }, [qc]);
}
